"use strict";
/* eslint-disable */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @deprecated does nothing
 */

exports.default = {
  attach: function attach() {},
  detach: function detach() {}
};